import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("span", {
    class: _normalizeClass($setup.props?.reverseColors ?'keplr-logoReversed' :'keplr-logo')
  }, _toDisplayString($props.letter), 3 /* TEXT, CLASS */))
}